import constants from '#packages/constants';
import superAppAddElementsPanel from '../panels/menuPanels/superAppAddElementsPanel';
import superAppLearnMorePanel from '../panels/menuPanels/superAppLearnMorePanel';
import superAppManagePanel from '../panels/menuPanels/superAppManagePanel';
import superAppPagesPanel from '../panels/menuPanels/superAppPagesPanel';

export const defaultTabsConfig = [
  {
    name: constants.SUPER_APPS.MENU_PANEL_TAB_NAMES.MANAGE,
    isDynamicHeight: false,
    content: superAppManagePanel,
    mappingKey: 'manage',
  },
  {
    name: constants.SUPER_APPS.MENU_PANEL_TAB_NAMES.PAGES,
    isDynamicHeight: true,
    content: superAppPagesPanel,
    mappingKey: 'pages',
  },
  {
    name: constants.SUPER_APPS.MENU_PANEL_TAB_NAMES.ADD,
    isDynamicHeight: true,
    content: superAppAddElementsPanel,
    mappingKey: 'addElements',
  },
  {
    name: constants.SUPER_APPS.MENU_PANEL_TAB_NAMES.LEARN_MORE,
    isDynamicHeight: false,
    content: superAppLearnMorePanel,
    mappingKey: 'learnMore',
  },
];
